import { ActivatedRouteSnapshot } from '@angular/router';

export function lookupParam(route: ActivatedRouteSnapshot, name: string) {
  while(route) {
    if(route.params[name]) {
      return route.params[name];
    }

    route = route.parent;
  }

  return null;
}